export default {"src":"/_next/static/media/eveningpost-logo.30b3fa8c.svg","height":57,"width":199,"blurWidth":0,"blurHeight":0};